import type { SVGProps } from 'react';

const SvgCheckFill = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill='none'
    height='1em'
    viewBox='0 0 24 24'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#CheckFill_svg__a)' fill='currentColor'>
      <path
        d='M12.059 24c6.627 0 12-5.373 12-12s-5.373-12-12-12c-6.628 0-12 5.373-12 12s5.372 12 12 12Z'
        fillOpacity={0.15}
      />
      <path d='M15.566 8.17a1.292 1.292 0 1 1 1.983 1.658l-2.642 3.162-.18.214-1.315 1.574-1.38 1.65a1.292 1.292 0 0 1-1.81.171l-.544-.445-1.197-.98-1.416-1.16-.086-.07-.24-.197a1.292 1.292 0 1 1 1.638-2l.24.197.085.07 1.416 1.16.714.584.037.03.09-.106.337-.403.132-.158 4.138-4.95Z' />
    </g>
    <defs>
      <clipPath id='CheckFill_svg__a'>
        <path d='M0 0h24v24H0z' fill='currentColor' transform='translate(.055)' />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCheckFill;
